import { useCallback, useMemo, useState } from 'react';

export type UpdateObj<T> = <K extends keyof T>(new_obj: T | Pick<T, K>) => void;

export function useObj<T>(defaults: T) {
  const [obj, setObj] = useState<T>(defaults);
  const updateObj: UpdateObj<T> = useCallback(<K extends keyof T>(new_obj: Pick<T, K> | T) => {
    setObj((current) => {
      return { ...current, ...new_obj };
    });
  }, []);

  return useMemo(() => {
    return { obj, setObj, updateObj };
  }, [obj, setObj, updateObj]);
}
